module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isShowTitle ? 'root' : ' nofoot'
  }, [_c('div', {
    staticClass: "icon-warp",
    on: {
      "touchstart": _vm.click
    }
  }, [_c('i', {
    class: _vm.data[_vm.title].className,
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.isShowTitle) ? _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.data[_vm.title].name))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cf4cfe6"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/items/iconButton.vue
// module id = 872
// module chunks = 1